import Vue from 'vue';
import Router from 'vue-router';
// import Hello from '@/components/Hello';
import Calculator from '@/components/Calculator';
import Settings from '@/components/Settings';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Calculator',
      component: Calculator,
    },
    {
      path: '/Settings',
      name: 'Settings',
      component: Settings,
    },
    {
      path: '/*',
      name: 'InvalidPath',
      component: Calculator,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js